import { memo, useState } from "react";

import { useChartsContext } from "contexts";
import styled from "styled-components/macro";

import { useChartEntities } from "hooks/charts";

import SlopeSettings from "./SlopeSettings";

function SlopeStyleSelector() {
  const { id } = useChartsContext();
  const { quarterSlope, unitSlope, halfSlope } = useChartEntities(id);
  const [customColors, setCustomColors] = useState([]);
  const [showColorChooser, setShowColorChooser] = useState("");

  const unitSlopeProps = {
    id,
    slopeType: "unitSlope",
    slope: unitSlope,
    label: "Unit Slope",
    showColorChooser,
    setShowColorChooser,
    customColors,
    setCustomColors
  };
  const halfSlopeProps = {
    id,
    slopeType: "halfSlope",
    slope: halfSlope,
    label: "Half Slope",
    showColorChooser,
    setShowColorChooser,
    customColors,
    setCustomColors
  };

  const quarterSlopeProps = {
    id,
    slopeType: "quarterSlope",
    slope: quarterSlope,
    label: "Quarter Slope",
    showColorChooser,
    setShowColorChooser,
    customColors,
    setCustomColors
  };

  return (
    <Wrapper>
      <SlopeSettings {...unitSlopeProps} />
      <SlopeSettings {...halfSlopeProps} />
      <SlopeSettings {...quarterSlopeProps} />
    </Wrapper>
  );
}

export default memo(SlopeStyleSelector);

const Wrapper = styled.div`
  display: grid;
  gap: 8px;
`;
